import {PlanTypeEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';

const {odonto, health, healthOdonto} = translations['pt-br'].others.selectionFlow.planType;

interface PlanTypeProps {
	color: 'info' | 'primary' | 'secondary';
	label: string;
	labelColor?: 'info' | 'primary' | 'secondary';
}

export const planTypeOptions: Record<PlanTypeEnum | string, PlanTypeProps> = {
	[PlanTypeEnum.ODONTO]: {
		label: odonto,
		color: 'secondary',
		labelColor: 'secondary',
	},
	[PlanTypeEnum.HEALTH]: {
		label: health,
		color: 'primary',
		labelColor: 'primary',
	},
	[PlanTypeEnum.HEALTH_ODONTO]: {
		label: healthOdonto,
		color: 'info',
		labelColor: 'primary',
	},
};
